export enum EmbloomItemType {
    notification = 106,
    primaryIndication = 102,
    remark = 103,
    scoreSubscale = 105,
    scoreTotal = 104,
    secondaryIndication = 107,
}
